import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';

function ProgressWithTarget({
  t,
  progress,
  showLabel,
  label,
  target,
  labelPercentage,
}) {
  const displayPercentageThreshold = 10;
  const displayProgressPercentage = progress >= displayPercentageThreshold;

  return (
    <div className="course-progress">
      {showLabel && (
        <div className="course-progress-label-container">
          <div className="course-progress-label">{label || t('progress')}</div>
          {labelPercentage && (
            <div className="course-progress-label-percentage">
              {labelPercentage}
            </div>
          )}
        </div>
      )}
      <div className="course-progress-values">
        <div className="course-progress-bar">
          <span
            style={{
              width: `${Math.min(progress, 100)}%`,
              paddingRight: displayProgressPercentage ? 10 : 0,
            }}
          >
            {displayProgressPercentage && `${Math.round(progress)}%`}
          </span>
        </div>
        <div className="progress-label">{target}</div>
      </div>
    </div>
  );
}

ProgressWithTarget.propTypes = {
  t: PropTypes.func.isRequired,
  progress: PropTypes.number.isRequired,
  showLabel: PropTypes.bool,
  label: PropTypes.string,
  labelPercentage: PropTypes.string,
  target: PropTypes.string,
};

ProgressWithTarget.defaultProps = {
  showLabel: true,
  label: '',
  labelPercentage: '',
  target: '',
};

export default translate(ProgressWithTarget);
